import { api } from '@src/api/api'
import { AccountsType, UserType } from '@src/types/user'
import { LastPaymentType, ServicesType } from '@src/store/ducks/user/types'

export enum SetNewPhoneType {
  MODILE = 1,
  NOTIFY = 2,
}

export type SetNewPhoneReq = {
  phone: string
  oldPhone: string
  type: SetNewPhoneType
}

export type SetNewEmailReq = {
  oldEmail: string
  email: string
}

type GetSumToPayType = {
  fio: string,
  balance: number,
  accountBalance: number,
  result: number
}
export type ProfileGameData = {
  surname: string,
  name: string,
  fatherName?: string,
  phone: string,
  contractNumber: string,
}

export type PersonalDataType = {
  // eslint-disable-next-line camelcase
  person_id: number;
  // eslint-disable-next-line camelcase
  second_name: string;
  // eslint-disable-next-line camelcase
  first_name: string;
  surname: string;
  // eslint-disable-next-line camelcase
  doc_no: string;
  // eslint-disable-next-line camelcase
  doc_serial: string;
  // eslint-disable-next-line camelcase
  adres_register: string;
  // eslint-disable-next-line camelcase
  vc_document: string;
  // eslint-disable-next-line camelcase
  document_date: string;
  // eslint-disable-next-line camelcase
  document_end_date: string;
}

export const userApi = {
  getMe() {
    return api.get<UserType>('/v1/user/profile')
  },
  getAccounts() {
    return api.get<AccountsType>('/v1/user/get-accounts')
  },
  setNewPhone(data: SetNewPhoneReq) {
    return api.post('/v1/user/change-phone', data)
  },
  getServices(accountId: number) {
    return api.get<ServicesType>('/v1/user/get-services-by-account', { accountId })
  },
  removeCard(accountId: number) {
    console.log('qwerty123321 === ', accountId)
    return api.del(`/v1/user/remove-card?account_id=${accountId}`)
  },
  getSumToPay(account: string) {
    return api.get<GetSumToPayType>('/v1/user/get-sum-to-pay', { account })
  },
  getLastPayment(accountId: number) {
    return api.get<LastPaymentType>('/v1/user/get-last-payment', { accountId })
  },
  setNewEmail(data: SetNewEmailReq) {
    return api.post('/v1/user/change-email', data)
  },
  setTerminationAgreement(account:string, accountId:number, comment:any) {
    return api.del('/v1/user/account-delete', { account, accountId, comment })
  },
  getTerminationCauses() {
    return api.get<string[]>('/v1/user/termination-causes')
  },
  changeFio(surName: string, firstName: string) {
    return api.post('/v1/user/change-fio', { surName, firstName })
  },
  setProfileField(fieldId: number, value: string) {
    return api.post('/v1/not-subscriber/profile/fields', { fieldId, value })
  },
  setProfileGame(data: ProfileGameData) {
    return api.post('/v1/game/send_game_form', {
      surname: data.surname,
      name: data.name,
      fatherName: data.fatherName,
      phone: data.phone,
      contractNumber: data.contractNumber,
    })
  },
  getProfileGameData() {
    return api.get('/v1/game/game_data')
  },
  getMessagesForUser(account: string) {
    return api.post<any>('/v1/user/get-messages', { account })
  },
  // getMessagesForUser3(account: string) {
  //   return api.post<any>('/v1/user/get-balance-balls', { account })
  // },
  // getMessagesForUser4(account: string) {
  //   return api.post<any>('/v1/user/get-history-balance', { account })
  // },
  updateMsgForUser(id: number, currentUserId: number) {
    return api.post<any>('/users/message-read', { message_id: id, user_id: currentUserId })
  },
  getPersonalData() {
    return api.get<PersonalDataType>('/v1/user/personal-data')
  },
  setPersonalData(data: PersonalDataType) {
    return api.post('/v1/user/personal-data', data)
  },
}
